const optionOriginal = [
    { value: null, label: 'All' },
    { value: "original work", label: 'Original work' },
    { value: "transcription", label: 'Transcription' }
];

const level = [
    { value: null, label: 'All' },
    { value: "Beginner", label: 'Beginner' },
    { value: "Intermediate", label: 'Intermediate' },
    { value: "Advanced", label: 'Advanced' }
];

const optionLevel = [
    { value: "Beginner", label: 'Beginner' },
    { value: "Intermediate", label: 'Intermediate' },
    { value: "Advanced", label: 'Advanced' }
];

const type = [
    { value: '1 piano 4 hands', label: '1 piano 4 hands' },
    { value: '2 pianos 4 hands', label: '2 pianos 4 hands' },
    { value: '1 piano 4 hands + ensemble (up to 9 instruments)', label: '1 piano 4 hands + ensemble (up to 9 instruments)' },
    { value: '2 pianos 4 hands + ensemble (up to 9 instruments)', label: '2 pianos 4 hands + ensemble (up to 9 instruments)' },
    { value: '1 piano 4 hands + orchestra', label: '1 piano 4 hands + orchestra' },
    { value: '2 pianos 4 hands + orchestra', label: '2 pianos 4 hands + orchestra' },
    { value: '3 pianos 6 hands', label: '3 pianos 6 hands' },
    { value: '3 pianos 6 hands + orchestra', label: '3 pianos 6 hands + orchestra' },
    { value: 'other', label: 'Other' }
];

const genderFilters = [
    { value: 'All', label: 'All' },
    { value: 'Man', label: 'Man' },
    { value: "Woman", label: 'Woman' },
    { value: "Others", label: 'Others' }
];

const genders = [
    { value: 'Man', label: 'Man' },
    { value: "Woman", label: 'Woman' },
    { value: "Others", label: 'Others' }
];

const optionMethod = [
    { value: "Piece", label: 'Piece' },
    { value: "compilation", label: 'Compilation' },
    { value: "method", label: 'Method' }
];

const fieldFilters = [
    {
        name: "GREAT REPERTOIRE",
        nameField: "greatRepertoire",
        help: "Find here the works for 4 hands and for 2 pianos which constitute the great repertoire. The selection is in constant evolution and is a subjective choice of the editorial committee."
    },
    {
        name: "METHOD",
        nameField: "typeOfFirstCard",
        help: "Find here the 4-hand learning methods, as well as the books for beginners"
    },
    {
        name: "CONCERTO",
        nameField: "concerto",
        help: "Find here concertos for 4 hands and orchestra or for 2 pianos and orchestra"
    },
    {
        name: "COMPILATION",
        nameField: "typeOfSecondCard",
        help: "Find here the collections which gather several works around a composer or a theme"
    },
    {
        name: "CONTEMPORARY MUSIC",
        nameField: "contemporainMusic",
        help: "Find here works composed after 2000"
    },
    {
        name: "PERFORMED AT RPPF",
        nameField: "perfomedAtRppf",
        help: "Find here the works that have been played at the Rungis Piano-Piano Festival"
    },
];

const country = [
    { "countries": "Afghanistan" },
    { "countries": "Åland Islands" },
    { "countries": "Albania" },
    { "countries": "Algeria" },
    { "countries": "American Samoa" },
    { "countries": "AndorrA" },
    { "countries": "Angola" },
    { "countries": "Anguilla" },
    { "countries": "Antarctica" },
    { "countries": "Antigua and Barbuda" },
    { "countries": "Argentina" },
    { "countries": "Armenia" },
    { "countries": "Aruba" },
    { "countries": "Australia" },
    { "countries": "Austria" },
    { "countries": "Azerbaijan" },
    { "countries": "Bahamas" },
    { "countries": "Bahrain" },
    { "countries": "Bangladesh" },
    { "countries": "Barbados" },
    { "countries": "Belarus" },
    { "countries": "Belgium" },
    { "countries": "Belize" },
    { "countries": "Benin" },
    { "countries": "Bermuda" },
    { "countries": "Bhutan" },
    { "countries": "Bolivia" },
    { "countries": "Bosnia and Herzegovina" },
    { "countries": "Botswana" },
    { "countries": "Bouvet Island" },
    { "countries": "Brazil" },
    { "countries": "British Indian Ocean Territory" },
    { "countries": "Brunei Darussalam" },
    { "countries": "Bulgaria" },
    { "countries": "Burkina Faso" },
    { "countries": "Burundi" },
    { "countries": "Cambodia" },
    { "countries": "Cameroon" },
    { "countries": "Canada" },
    { "countries": "Cape Verde" },
    { "countries": "Cayman Islands" },
    { "countries": "Central African Republic" },
    { "countries": "Chad" },
    { "countries": "Chile" },
    { "countries": "China" },
    { "countries": "Christmas Island" },
    { "countries": "Cocos (Keeling) Islands" },
    { "countries": "Colombia" },
    { "countries": "Comoros" },
    { "countries": "Congo" },
    { "countries": "Congo, The Democratic Republic of the" },
    { "countries": "Cook Islands" },
    { "countries": "Costa Rica" },
    { "countries": "Croatia" },
    { "countries": "Cuba" },
    { "countries": "Cyprus" },
    { "countries": "Czech Republic" },
    { "countries": "Denmark" },
    { "countries": "Djibouti" },
    { "countries": "Dominica" },
    { "countries": "Dominican Republic" },
    { "countries": "Ecuador" },
    { "countries": "Egypt" },
    { "countries": "El Salvador" },
    { "countries": "Equatorial Guinea" },
    { "countries": "Eritrea" },
    { "countries": "Estonia" },
    { "countries": "Ethiopia" },
    { "countries": "Falkland Islands (Malvinas)" },
    { "countries": "Faroe Islands" },
    { "countries": "Fiji" },
    { "countries": "Finland" },
    { "countries": "France" },
    { "countries": "French Guiana" },
    { "countries": "French Polynesia" },
    { "countries": "French Southern Territories" },
    { "countries": "Gabon" },
    { "countries": "Gambia" },
    { "countries": "Georgia" },
    { "countries": "Germany" },
    { "countries": "Ghana" },
    { "countries": "Gibraltar" },
    { "countries": "Greece" },
    { "countries": "Greenland" },
    { "countries": "Grenada" },
    { "countries": "Guadeloupe" },
    { "countries": "Guam" },
    { "countries": "Guatemala" },
    { "countries": "Guernsey" },
    { "countries": "Guinea" },
    { "countries": "Guinea-Bissau" },
    { "countries": "Guyana" },
    { "countries": "Haiti" },
    { "countries": "Heard Island and Mcdonald Islands" },
    { "countries": "Holy See (Vatican City State)" },
    { "countries": "Honduras" },
    { "countries": "Hong Kong" },
    { "countries": "Hungary" },
    { "countries": "Iceland" },
    { "countries": "India" },
    { "countries": "Indonesia" },
    { "countries": "Iran, Islamic Republic Of" },
    { "countries": "Iraq" },
    { "countries": "Ireland" },
    { "countries": "Isle of Man" },
    { "countries": "Israel" },
    { "countries": "Italy" },
    { "countries": "Jamaica" },
    { "countries": "Japan" },
    { "countries": "Jersey" },
    { "countries": "Jordan" },
    { "countries": "Kazakhstan" },
    { "countries": "Kenya" },
    { "countries": "Kiribati" },
    { "countries": "Korea, Republic of" },
    { "countries": "Kuwait" },
    { "countries": "Kyrgyzstan" },
    { "countries": "Latvia" },
    { "countries": "Lebanon" },
    { "countries": "Lesotho" },
    { "countries": "Liberia" },
    { "countries": "Libyan Arab Jamahiriya" },
    { "countries": "Liechtenstein" },
    { "countries": "Lithuania" },
    { "countries": "Luxembourg" },
    { "countries": "Macao" },
    { "countries": "Macedonia" },
    { "countries": "Madagascar" },
    { "countries": "Malawi" },
    { "countries": "Malaysia" },
    { "countries": "Maldives" },
    { "countries": "Mali" },
    { "countries": "Malta" },
    { "countries": "Marshall Islands" },
    { "countries": "Martinique" },
    { "countries": "Mauritania" },
    { "countries": "Mauritius" },
    { "countries": "Mayotte" },
    { "countries": "Mexico" },
    { "countries": "Micronesia, Federated States of" },
    { "countries": "Moldova, Republic of" },
    { "countries": "Monaco" },
    { "countries": "Mongolia" },
    { "countries": "Montserrat" },
    { "countries": "Morocco" },
    { "countries": "Mozambique" },
    { "countries": "Myanmar" },
    { "countries": "Namibia" },
    { "countries": "Nauru" },
    { "countries": "Nepal" },
    { "countries": "Netherlands" },
    { "countries": "Netherlands Antilles" },
    { "countries": "New Caledonia" },
    { "countries": "New Zealand" },
    { "countries": "Nicaragua" },
    { "countries": "Niger" },
    { "countries": "Nigeria" },
    { "countries": "Niue" },
    { "countries": "Norfolk Island" },
    { "countries": "Northern Mariana Islands" },
    { "countries": "Norway" },
    { "countries": "Oman" },
    { "countries": "Pakistan" },
    { "countries": "Palau" },
    { "countries": "Palestinian Territory, Occupied" },
    { "countries": "Panama" },
    { "countries": "Papua New Guinea" },
    { "countries": "Paraguay" },
    { "countries": "Peru" },
    { "countries": "Philippines" },
    { "countries": "Pitcairn" },
    { "countries": "Poland" },
    { "countries": "Portugal" },
    { "countries": "Puerto Rico" },
    { "countries": "Qatar" },
    { "countries": "Reunion" },
    { "countries": "Romania" },
    { "countries": "Russian Federation" },
    { "countries": "Rwanda" },
    { "countries": "Saint Helena" },
    { "countries": "Saint Kitts and Nevis" },
    { "countries": "Saint Lucia" },
    { "countries": "Saint Pierre and Miquelon" },
    { "countries": "Saint Vincent and the Grenadines" },
    { "countries": "Samoa" },
    { "countries": "San Marino" },
    { "countries": "Sao Tome and Principe" },
    { "countries": "Saudi Arabia" },
    { "countries": "Senegal" },
    { "countries": "Serbia and Montenegro" },
    { "countries": "Seychelles" },
    { "countries": "Sierra Leone" },
    { "countries": "Singapore" },
    { "countries": "Slovakia" },
    { "countries": "Slovenia" },
    { "countries": "Solomon Islands" },
    { "countries": "Somalia" },
    { "countries": "South Africa" },
    { "countries": "South Georgia and the South Sandwich Islands" },
    { "countries": "Spain" },
    { "countries": "Sri Lanka" },
    { "countries": "Sudan" },
    { "countries": "Suriname" },
    { "countries": "Svalbard and Jan Mayen" },
    { "countries": "Swaziland" },
    { "countries": "Sweden" },
    { "countries": "Switzerland" },
    { "countries": "Syrian Arab Republic" },
    { "countries": "Taiwan, Province of China" },
    { "countries": "Tajikistan" },
    { "countries": "Tanzania, United Republic of" },
    { "countries": "Thailand" },
    { "countries": "Timor-Leste" },
    { "countries": "Togo" },
    { "countries": "Tokelau" },
    { "countries": "Tonga" },
    { "countries": "Trinidad and Tobago" },
    { "countries": "Tunisia" },
    { "countries": "Turkey" },
    { "countries": "Turkmenistan" },
    { "countries": "Turks and Caicos Islands" },
    { "countries": "Tuvalu" },
    { "countries": "Uganda" },
    { "countries": "Ukraine" },
    { "countries": "United Arab Emirates" },
    { "countries": "United Kingdom" },
    { "countries": "United States" },
    { "countries": "United States Minor Outlying Islands" },
    { "countries": "Uruguay" },
    { "countries": "Uzbekistan" },
    { "countries": "Vanuatu" },
    { "countries": "Venezuela" },
    { "countries": "Viet Nam" },
    { "countries": "Virgin Islands, British" },
    { "countries": "Virgin Islands, U.S." },
    { "countries": "Wallis and Futuna" },
    { "countries": "Western Sahara" },
    { "countries": "Yemen" },
    { "countries": "Zambia" },
    { "countries": "Zimbabwe" }
];

export {
    level,
    type,
    genderFilters,
    genders,
    fieldFilters,
    optionLevel,
    optionMethod,
    optionOriginal,
    country
}

